export const UPLOAD_USER_DATA = 'UPLOAD_USER_DATA'
export const UPLOAD_USER_DATA_BY_ID = 'UPLOAD_USER_DATA_BY_ID'
export const CLEAR_USER_ID_DATA = 'CLEAR_USER_ID_DATA'
export const CLEAR_EXPERT_ID_DATA = 'CLEAR_EXPERT_ID_DATA'
export const UPLOAD_EXPERT_DATA = 'UPLOAD_EXPERT_DATA'
export const UPLOAD_EXPERT_ID = 'UPLOAD_EXPERT_ID'
export const SET_EXPORT_USERS_DATA = 'SET_EXPORT_USERS_DATA'
export const SET_EXPERTS_LIST = 'SET_EXPERTS_LIST'
export const SET_RATING_DATA = 'SET_RATING_DATA'